import { render, staticRenderFns } from "./RecoveryByEmailOrPhone.vue?vue&type=template&id=238d50f0&scoped=true&"
import script from "./RecoveryByEmailOrPhone.vue?vue&type=script&lang=js&"
export * from "./RecoveryByEmailOrPhone.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryByEmailOrPhone.vue?vue&type=style&index=0&id=238d50f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238d50f0",
  null
  
)

export default component.exports